import type { Template } from "@/types";

export const LA_07_H3_V4: Template[] = [
{
    id: "la-07-h3v4-01",
    name: "LA 01 - H3V4",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-07-h3_v4_01.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 102, y: 185, width: 434, height: 251, rotation: 0, imageRotation: 0 },
            { id: "2", x: 102, y: 40, width: 214, height: 137, rotation: 0, imageRotation: 0 },
            { id: "3", x: 323, y: 40, width: 214, height: 137, rotation: 0, imageRotation: 0 },
            { id: "4", x: 794, y: 40, width: 158, height: 195, rotation: 0, imageRotation: 0 },
            { id: "5", x: 794, y: 242, width: 158, height: 194, rotation: 0, imageRotation: 0 },
            { id: "6", x: 960, y: 40, width: 157, height: 195, rotation: 0, imageRotation: 0 },
            { id: "7", x: 960, y: 242, width: 157, height: 194, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-07-h3v4-02",
    name: "LA 02 - H3V4",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-07-h3_v4_02.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 74, y: 40, width: 187, height: 126, rotation: 0, imageRotation: 0 },
            { id: "2", x: 74, y: 174, width: 187, height: 126, rotation: 0, imageRotation: 0 },
            { id: "3", x: 74, y: 308, width: 187, height: 126, rotation: 0, imageRotation: 0 },
            { id: "4", x: 269, y: 40, width: 286, height: 394, rotation: 0, imageRotation: 0 },
            { id: "5", x: 737, y: 40, width: 285, height: 394, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1028, y: 40, width: 138, height: 194, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1028, y: 241, width: 138, height: 194, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-07-h3v4-03",
    name: "LA 03 - H3V4",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-07-h3_v4_03.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 104, y: 41, width: 428, height: 254, rotation: 0, imageRotation: 0 },
            { id: "2", x: 104, y: 301, width: 211, height: 136, rotation: 0, imageRotation: 0 },
            { id: "3", x: 322, y: 301, width: 210, height: 136, rotation: 0, imageRotation: 0 },
            { id: "4", x: 758, y: 39, width: 282, height: 399, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1047, y: 39, width: 106, height: 128, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1047, y: 175, width: 106, height: 128, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1047, y: 310, width: 106, height: 127, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-07-h3v4-04",
    name: "LA 04 - H3V4",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-07-h3_v4_04.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 44, y: 57, width: 171, height: 117, rotation: 0, imageRotation: 0 },
            { id: "2", x: 44, y: 180, width: 171, height: 117, rotation: 0, imageRotation: 0 },
            { id: "3", x: 44, y: 304, width: 171, height: 116, rotation: 0, imageRotation: 0 },
            { id: "4", x: 222, y: 57, width: 237, height: 361, rotation: 0, imageRotation: 0 },
            { id: "5", x: 466, y: 57, width: 126, height: 177, rotation: 0, imageRotation: 0 },
            { id: "6", x: 466, y: 242, width: 126, height: 177, rotation: 0, imageRotation: 0 },
            { id: "7", x: 806, y: 36, width: 299, height: 404, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-07-h3v4-05",
    name: "LA 05 - H3V4",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-07-h3_v4_05.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 213, y: 38, width: 211, height: 130, rotation: 0, imageRotation: 0 },
            { id: "2", x: 213, y: 175, width: 211, height: 129, rotation: 0, imageRotation: 0 },
            { id: "3", x: 213, y: 311, width: 211, height: 129, rotation: 0, imageRotation: 0 },
            { id: "4", x: 807, y: 38, width: 146, height: 198, rotation: 0, imageRotation: 0 },
            { id: "5", x: 807, y: 243, width: 146, height: 198, rotation: 0, imageRotation: 0 },
            { id: "6", x: 959, y: 38, width: 146, height: 198, rotation: 0, imageRotation: 0 },
            { id: "7", x: 959, y: 243, width: 146, height: 198, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-07-h3v4-06",
    name: "LA 06 - H3V4",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-07-h3_v4_06.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 55, y: 39, width: 286, height: 183, rotation: 0, imageRotation: 0 },
            { id: "2", x: 55, y: 229, width: 139, height: 208, rotation: 0, imageRotation: 0 },
            { id: "3", x: 202, y: 229, width: 139, height: 208, rotation: 0, imageRotation: 0 },
            { id: "4", x: 349, y: 39, width: 286, height: 183, rotation: 0, imageRotation: 0 },
            { id: "5", x: 349, y: 229, width: 139, height: 208, rotation: 0, imageRotation: 0 },
            { id: "6", x: 495, y: 229, width: 139, height: 208, rotation: 0, imageRotation: 0 },
            { id: "7", x: 641, y: 39, width: 578, height: 399, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-07-h3v4-07",
    name: "LA 07 - H3V4",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-07-h3_v4_07.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 0, y: 52, width: 269, height: 370, rotation: 0, imageRotation: 0 },
            { id: "2", x: 275, y: 52, width: 267, height: 370, rotation: 0, imageRotation: 0 },
            { id: "3", x: 549, y: 52, width: 269, height: 370, rotation: 0, imageRotation: 0 },
            { id: "4", x: 825, y: 52, width: 176, height: 119, rotation: 0, imageRotation: 0 },
            { id: "5", x: 825, y: 177, width: 176, height: 119, rotation: 0, imageRotation: 0 },
            { id: "6", x: 825, y: 304, width: 176, height: 119, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1007, y: 52, width: 267, height: 370, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-07-h3v4-08",
    name: "LA 08 - H3V4",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-07-h3_v4_08.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 56, y: 39, width: 578, height: 399, rotation: 0, imageRotation: 0 },
            { id: "2", x: 641, y: 39, width: 286, height: 183, rotation: 0, imageRotation: 0 },
            { id: "3", x: 934, y: 39, width: 286, height: 183, rotation: 0, imageRotation: 0 },
            { id: "4", x: 641, y: 229, width: 139, height: 208, rotation: 0, imageRotation: 0 },
            { id: "5", x: 787, y: 229, width: 139, height: 208, rotation: 0, imageRotation: 0 },
            { id: "6", x: 934, y: 229, width: 139, height: 208, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1080, y: 229, width: 139, height: 208, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-07-h3v4-09",
    name: "LA 09 - H3V4",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-07-h3_v4_09.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 0, y: 40, width: 264, height: 394, rotation: 0, imageRotation: 0 },
            { id: "2", x: 271, y: 40, width: 191, height: 126, rotation: 0, imageRotation: 0 },
            { id: "3", x: 271, y: 174, width: 191, height: 126, rotation: 0, imageRotation: 0 },
            { id: "4", x: 271, y: 308, width: 191, height: 126, rotation: 0, imageRotation: 0 },
            { id: "5", x: 469, y: 40, width: 264, height: 394, rotation: 0, imageRotation: 0 },
            { id: "6", x: 740, y: 40, width: 263, height: 394, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1010, y: 40, width: 263, height: 394, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-07-h3v4-10",
    name: "LA 10 - H3V4",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-07-h3_v4_10.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 0, y: 40, width: 264, height: 394, rotation: 0, imageRotation: 0 },
            { id: "2", x: 271, y: 40, width: 263, height: 394, rotation: 0, imageRotation: 0 },
            { id: "3", x: 542, y: 40, width: 263, height: 394, rotation: 0, imageRotation: 0 },
            { id: "4", x: 812, y: 40, width: 263, height: 394, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1083, y: 40, width: 191, height: 126, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1083, y: 175, width: 191, height: 125, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1083, y: 309, width: 191, height: 125, rotation: 0, imageRotation: 0 }
    ],
}
];